<template>
  <base-dialog :showDialog="showDialog">
    <template v-slot:body>
      <v-sheet v-if="isLoading" class="pa-3" dark>
        <v-skeleton-loader
          class="mx-auto"
          max-height="768"
          type="card"
        ></v-skeleton-loader>
      </v-sheet>
      <v-card dark v-else>
        <v-card-title>
          <div class="d-flex justify-space-around">
            <span class="text-h6">Fabricante Integração</span>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col>
              <c-input
                label="Descrição"
                placeholder="Descrição Fabricante"
                v-model="manufacturer.nome"
                :maxLength="12"
              />
            </v-col>
          </v-row>
          <v-row dense v-if="isUpdate">
            <v-col cols="4">
              <c-input
                label="ID Tray"
                placeholder="Código Tray"
                v-model="manufacturer.idIntegracao"
                type="number"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <form-buttons
          @goBack="$emit('goBack')"
          @submitForm="submitForm(manufacturer, 'form')"
        />
      </v-card>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {
    BaseDialog: () => import('@/components/shared/base-dialog/BaseDialog'),
    FormButtons: () => import('@/components/shared/base-buttons/FormButtons'),
    cInput: () => import('@/components/shared/base-input/BaseInput.vue'),
  },
  data: () => {
    return {
      isLoading: true,
      isUpdate: false,
      manufacturer: {
        nome: null,
        idIntegracao: null,
      },
    }
  },
  methods: {
    ...mapActions({
      getManufacturerIntegration: 'trayModule/getManufacturerIntegration',
      translateManufacturerFromFirebird:
        'trayModule/translateManufacturerFromFirebird',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
    }),
    async fetch() {
      try {
        var obj = await this.translateManufacturerFromFirebird(this.objectData)

        if (this.objectData.FABRICANTE && this.objectData.INTEGRACAO) {
          let manufacturer = await this.getManufacturerIntegration(obj.nome)
          if (manufacturer)
            this.manufacturer = {
              ...manufacturer,
            }

          this.isUpdate = !this.isUpdate
        } else
          this.manufacturer = {
            ...obj,
          }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
      this.isLoading = false
    },
  },
  mounted() {
    this.fetch()
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    objectData: {
      type: Object,
      default: () => {},
      required: true,
    },
    submitForm: {
      type: Function,
    },
  },
}
</script>

<style></style>
